import { ResponsiveSidebar } from "./responsive-sidebar";
import { Sidebar } from "./sidebar";

export const Navbar = () => {
  return (
    <>
      <ResponsiveSidebar />

      <div className="hidden h-dvh lg:block">
        <Sidebar />
      </div>
    </>
  );
};
